import { render } from "./Header.vue?vue&type=template&id=03673ec1&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/assets/scss/_header.scss?vue&type=style&index=0&id=03673ec1&lang=scss&scoped=true"
import "./Header.vue?vue&type=style&index=1&id=03673ec1&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03673ec1"]])

export default __exports__